import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import Body from '../body/Dream';
import Hero from '../hero/hero';
import BreadCrumb from '../utility/breadCrumb';

function Index() {
  return (
    <>
      <BreadCrumb 
        linkto="dream" 
        linkname="Play The Way You Dream Of" 
        linklevel="1" 
        linktoone="" 
        linknameone=""
        linktotwo="" 
        linknametwo="" 
      >
      </BreadCrumb>
      <Hero 
        paddingTop = "0px"
        id="4" 
        contentId="4" 
        height="300" 
        gradient="true" 
        gradientDirection="to right" 
        gradientRgba="rgba(255,255,255,1) 70%, transparent" 
        backgroundSize="auto 100%" 
        backgroundRepeat="no-repeat" 
        backgroundColor="#fff" 
        backgroundPosition="right"
        borderwidth="1"
        bordercolor="#9E2218"
        bordertype="solid"
        maxWidth="1400px"
        margin="auto"  >
      </Hero>
      <Body id="5"></Body>
    </>
  );
}

export default Index;
